<template>
  <div :class="['base-card', variant, { 'no-padding': noPadding }]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseCard',
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'highlighted', 'transparent'].includes(value)
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.base-card {
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  padding: var(--spacing-lg);
  border: 2px solid var(--color-border);
}

.base-card.highlighted {
  background: rgb(6, 31, 28);
  border-color: rgb(8, 43, 39);
}

.base-card.transparent {
  background: transparent;
  border: none;
}

.base-card.no-padding {
  padding: 0;
}
</style>

